import { CardHeader } from "reactstrap";
import { DashboardCommonHeaderType } from "../../../Types/CommonComponentsType";
import { CommonDropdown } from "../CommonDropdown/CommonDropdown";
import { H5 } from "../../../AbstractElements";

const DashboardCommonHeader:React.FC<DashboardCommonHeaderType> = ({ title, tagClass, dropDownFalse, children, dropdownTitle, dropdownClass }) => {
  return (
    <CardHeader className="card-no-border">
      <div className="header-top">
        <H5 className={tagClass ? tagClass : ""}>{title}</H5>
        {!dropDownFalse && <CommonDropdown dropdownTitle={dropdownTitle} dropdownClass={dropdownClass} />}
        {children}
      </div>
    </CardHeader>
  );
};

export default DashboardCommonHeader;
